import React, {
  createContext,
  useContext,
  useState,
  useRef,
  useCallback,
  useEffect,
} from "react";
import axiosInstance from "../Config/axios";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";

const NewUserContext = createContext();
export const useNewUser = () => useContext(NewUserContext);

export const NewUserContextProvider = ({ children }) => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cartItemsNew, setCartItemsNew] = useState([]);
  const [couponsNew, setCouponsNew] = useState([]);
  const [error, setError] = useState(null);
  const [packageCategories, setPackageCategories] = useState([]);
  const [cartRe, setCartRe] = useState(0);
  const [summercampList, setSummerCampList] = useState([]);
  const [isGuestSummerCampCheckingOut, SetGuestSummerCampCheckingOut] =
    useState(false);
  const [dataVpaymentGuest, setDataVpaymentGuest] = useState(null);

  const time_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const fetchGroupInstructions = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/customer/packages/", {
        params: { timezone: time_Zone },
      });
      setPackages(response.data || []);
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch packages";
      setError(errorDetail);
      console.log("Error fetching packages:", errorDetail);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchInstructionCategories = useCallback(async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(
        `/customer/packages/category/${id}/`,
        {
          params: { timezone: time_Zone },
        },
      );
      setPackageCategories(response.data || []);
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch packages";
      setError(errorDetail);
      console.log("Error fetching package categories:", errorDetail);
    } finally {
      setLoading(false);
    }
  }, []);

  const addToCart = async (data) => {
    try {
      setLoading(true);

      const response = await axiosInstance.post(
        "/customer/cart/add/new/",
        data,
        {
          params: { timezone: time_Zone },
        },
      );

      // setParentProfile(response.data);
      Swal.fire({
        icon: "success",
        title: "Added to Cart!",
        text: "Your session has been added to the cart successfully.",
        showConfirmButton: true,
        confirmButtonText: "Go to Cart",
        showCancelButton: true,
        cancelButtonText: "Continue Shopping",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/cart";
        }

        if (result.dismiss === Swal.DismissReason.cancel) {
          window.location.href = "/instruction/";
        }
      });

      return { success: true, data: response.data };
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: err.response?.data?.detail || "Something went wrong.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const fetchCartItemsNew = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(`customer/new/list-cart/`, {
        params: { timezone: time_Zone },
      });
      setCartItemsNew(response.data || []);
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch packages";
      setError(errorDetail);
      console.log("Error fetching cart items:", errorDetail);
    } finally {
      setLoading(false);
    }
  };

  const removeFromCartNew = async (id) => {
    setLoading(true);
    setError(null);
    const data = { cart_item_id: id };
    try {
      const response = await axiosInstance.post(
        `/customer/new/cart-remove/`,
        data,
      );
      // await fetchCartItemsNew();
      // await fetchCartCount();
      // Swal.fire({
      //   icon: "success",
      //   title: "Success !",
      //   text: `${response.data?.message || "Cart Item deleted successfully."}`,
      //   confirmButtonColor: "#f7931a",
      //   cancelButtonColor: "#1C1C1C",
      // });

      // setParentProfile(response.data);
      Swal.fire({
        icon: "success",
        title: "Deleted from Cart!",
        text: "Your item has been deleted from the cart successfully.",
        showConfirmButton: true,
        confirmButtonText: "Go to Cart",
        showCancelButton: true,
        cancelButtonText: "Continue Shopping",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/cart";
        }

        if (result.dismiss === Swal.DismissReason.cancel) {
          window.location.href = "/instruction/";
        }
      });
      return { success: true, data: response.data };
    } catch (err) {
      const errorDetail = err.response?.data || {
        detail: "Failed to delete Item",
      };
      Swal.fire({
        icon: "error",
        title: "Error !",
        text: `${
          errorDetail.detail || "An error occurred while deleting the Item."
        }`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false, error: errorDetail };
    } finally {
      setLoading(false);
    }
  };
  const removeCuponGuest = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.post(`/customer/v2/remove-coupon/`);
      await fetchCartItemsNew();
      Swal.fire({
        icon: "success",
        title: "Success !",
        text: `${response.data?.message || "Coupon removed successfully"}`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: true, data: response.data };
    } catch (err) {
      const errorDetail = err.response?.data || {
        detail: "Failed to delete Item",
      };
      Swal.fire({
        icon: "error",
        title: "Error !",
        text: `${
          errorDetail.detail || "An error occurred while removeing the Coupon."
        }`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false, error: errorDetail };
    } finally {
      setLoading(false);
    }
  };

  const fetchCouponsNew = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(
        `/customer/new/list-user-coupons/`,
      );
      setCouponsNew(response.data || []);
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch packages";
      setError(errorDetail);
      console.log("Error fetching coupons:", errorDetail);
    } finally {
      setLoading(false);
    }
  };

  const applyCouponNew = async (data) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/customer/v2/apply-coupon/",
        data,
        {
          params: { timezone: time_Zone },
        },
      );
      return { success: true, data: response.data };
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error !",
        text: `${err.detail || "Invalid coupon"}`,
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const proceedToCheckoutGuest = async (data) => {
    setLoading(true);

    try {
      // 1️⃣ Validate required email
      if (!data?.parent?.email) {
        Swal.fire({
          icon: "warning",
          title: "Missing Email",
          text: "Email is required to continue",
          confirmButtonColor: "#f7931a",
        });
        return { success: false };
      }

      // 2️⃣ Validate email availability (send ONLY email)
      const validateEmail = await axiosInstance.post(
        "/customer/validate-email/",
        { email: data.parent.email },
        {
          params: { timezone: time_Zone },
        },
      );

      if (!validateEmail.data?.available) {
        Swal.fire({
          icon: "error",
          title: "Email Already Exists",
          text: "This email is already registered.",
          confirmButtonColor: "#f7931a",
        });
        return { success: false };
      }

      // 3️⃣ Proceed to guest checkout
      const response = await axiosInstance.post(
        "/payment/new/checkout/guest/",
        data,
        {
          params: { timezone: time_Zone },
        },
      );

      return { success: true, data: response.data };
    } catch (err) {
      console.error(err);

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const verifyPaymentStatusGuest = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(
        `/payment/verify_payment/?session_id=${id}`,
        { params: { timezone: time_Zone } },
      );

      return response.data;
    } catch (err) {
      const errorDetail = err.response?.data?.detail || "Something went wrong";
      setError(errorDetail);
      console.log("Error verifying payment status:", errorDetail);
    } finally {
      setLoading(false);
    }
  };

  const fetchCartCount = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/customer/header-metadata/`);
      setCartRe(response.data?.cart_item_count);
      return response.data;
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch cart count";
      setError(errorDetail);
      console.log("Error fetching coupons:", errorDetail);
    } finally {
      setLoading(false);
    }
  };

  const getSummerCampList = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`services/get-offering`);
      setSummerCampList(response?.data);
      return response.data;
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to fetch summer camp list";
      setError(errorDetail);
      console.log("Error fetching coupons:", errorDetail);
    } finally {
      setLoading(false);
    }
  };

  const calculateSummerCampPrice = async ({ players = 1, weeks }) => {
    if (!weeks) return null;

    // setLoading(true);
    setError(null);

    try {
      const weeksParam = players > 1 ? `${players},${weeks}` : `${weeks}`;

      const response = await axiosInstance.get(`/services/calculate-price`, {
        params: {
          weeks: weeksParam,
        },
      });

      return response.data;
    } catch (err) {
      const errorDetail =
        err.response?.data?.detail || "Failed to calculate price";
      setError(errorDetail);
      console.error("Error calculating price:", errorDetail);
      return null;
    } finally {
      // setLoading(false);
    }
  };

  const addToCartOffering = async (payload) => {
    setError(null);

    try {
      const response = await axiosInstance.post(
        "/services/guest/offering-cart/",
        payload,
      );
      Swal.fire({
        icon: "success",
        title: "Added to Cart!",
        text: "Your session has been added to the cart successfully.",
        showConfirmButton: true,
        confirmButtonText: "Go to Cart",
        showCancelButton: true,
        cancelButtonText: "Continue Shopping",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/cart";
        }
        if (result.isDismissed) {
          // Do nothing, just close the modal
          window.location.href = "/basketball-summer-camps-details";
        }
      });
      return response.data;
    } catch (err) {
      const errorDetail = err.response?.data?.detail || "Failed to add to cart";
      setError(errorDetail);
      console.error("Error adding to cart:", errorDetail);
      return null;
    }
  };

  const proceedToOfferingCheckoutGuest = async (data) => {
    setError(null);

    try {
      SetGuestSummerCampCheckingOut(true);
      if (!data?.cart_id) {
        Swal.fire({
          icon: "warning",
          title: "Missing Cart",
          text: "Cart ID is required to proceed",
          confirmButtonColor: "#f7931a",
        });
        return { success: false };
      }

      if (!data?.parent?.email) {
        Swal.fire({
          icon: "warning",
          title: "Missing Email",
          text: "Email is required to continue",
          confirmButtonColor: "#f7931a",
        });
        return { success: false };
      }

      const validateEmail = await axiosInstance.post(
        "/customer/validate-email/",
        { email: data.parent.email },
        { params: { timezone: time_Zone } },
      );

      if (!validateEmail.data?.available) {
        Swal.fire({
          icon: "error",
          title: "Email Already Exists",
          text: "This email is already registered. Please login.",
          confirmButtonColor: "#f7931a",
        });
        return { success: false };
      }

      const response = await axiosInstance.post(
        "/services/guest/offering-checkout/",
        data,
      );
      const checkoutUrl = response?.data?.url;

      if (checkoutUrl) {
        window.location.href = checkoutUrl;
      } else {
        throw new Error("Checkout URL not found");
      }
      return { success: true, data: response.data };
    } catch (err) {
      console.error("Offering checkout error:", err);

      Swal.fire({
        icon: "error",
        title: "Checkout Failed",
        text:
          err.response?.data?.detail ||
          "Something went wrong while processing checkout.",
        confirmButtonColor: "#f7931a",
      });

      return { success: false };
    } finally {
      SetGuestSummerCampCheckingOut(false);
    }
  };

  const verifyPaymentGuest = async (id) => {
    try {
      const response = await axiosInstance.get(
        `/payment/verify_payment/?session_id=${id}`,
      );
      if (response?.data) {
        setDataVpaymentGuest(response.data);
        return response.data;
      }

      return [];
    } catch (err) {
      setDataVpaymentGuest(null);
      const message = err.response?.data?.message || "Failed to Verify Payment";

      Swal.fire({
        icon: "error",
        title: "Error",
        text: message,
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  const applyCampCouponGust = async (payload) => {
    try {
      setLoading(true);
      setError(null);

      // Payload expects: { "cart_id": 30, "code": "CouponCode" }
      const response = await axiosInstance.post(
        "/services/apply-camp-coupon/",
        payload,
      );

      Swal.fire({
        icon: "success",
        title: "Coupon Applied!",
        text: `You saved $${response.data.discount_value ? response.data.discount_value : response.data.discounted_amount}!`,
        timer: 2000,
        showConfirmButton: false,
      });

      return response.data;
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Invalid Coupon Code";
      setError(message);

      // Return error structure so UI can handle message display
      return { success: false, message: message };
    } finally {
      setLoading(false);
    }
  };

  const removeCampCouponGust = async (cartId) => {
    try {
      // setLoading(true);
      setError(null);

      const response = await axiosInstance.post(
        "/services/offering/remove-coupon/",
        { cart_id: cartId },
      );

      Swal.fire({
        icon: "success",
        title: "Coupon Removed",
        text: response.data.message || "Coupon removed successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      return response.data;
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Failed to remove coupon";

      setError(message);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: message,
      });

      return null;
    } finally {
      // setLoading(false);
    }
  };

  return (
    <NewUserContext.Provider
      value={{
        loading,
        error,
        fetchGroupInstructions,
        packages,
        fetchInstructionCategories,
        packageCategories,
        addToCart,
        fetchCartItemsNew,
        cartItemsNew,
        removeFromCartNew,
        fetchCouponsNew,
        couponsNew,
        applyCouponNew,
        proceedToCheckoutGuest,
        verifyPaymentStatusGuest,
        removeCuponGuest,
        fetchCartCount,
        cartRe,
        getSummerCampList,
        summercampList,
        calculateSummerCampPrice,
        addToCartOffering,
        proceedToOfferingCheckoutGuest,
        isGuestSummerCampCheckingOut,
        verifyPaymentGuest,
        dataVpaymentGuest,
        applyCampCouponGust,
        removeCampCouponGust,
      }}
    >
      {loading && <Loader />}

      {children}
    </NewUserContext.Provider>
  );
};
